import { render } from "./LegalTermsText.vue?vue&type=template&id=03cbb6d9"
import script from "./LegalTermsText.vue?vue&type=script&lang=js"
export * from "./LegalTermsText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__